import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const ShareIcon = (props: SvgIconProps) => (
    <SvgIcon {...props} viewBox="0 0 24 24">
        <path fillRule="evenodd" clipRule="evenodd" d="M18.86.5a3.83 3.83 0 0 1 0 7.66h-.2a3.8 3.8 0 0 1-2.31-.79L9.12 11.6a3.4 3.4 0 0 1 0 1.04l7.32 4.26a3.7 3.7 0 0 1 2.23-.75h.19a3.75 3.75 0 0 1 3.55 3.75v.2a3.75 3.75 0 0 1-3.55 3.54h-.2c-2 0-3.63-1.57-3.73-3.55v-.2c0-.15 0-.3.03-.46l-7.31-4.27a3.83 3.83 0 1 1 0-6.08l7.23-4.21A3.83 3.83 0 0 1 18.67.5h.2Zm-.2 18.3a1.11 1.11 0 0 0 0 2.22c.62 0 1.12-.5 1.12-1.1 0-.62-.5-1.12-1.11-1.12ZM5.34 11a1.11 1.11 0 0 0 0 2.22c.62 0 1.12-.5 1.12-1.11 0-.61-.5-1.11-1.12-1.11Zm13.34-7.78a1.11 1.11 0 1 0 1.11 1.12c0-.62-.5-1.12-1.11-1.12Z" />
    </SvgIcon>
);
